import React from "react";
import { Star } from "lucide-react";

/**
 * Rating renderer/picker.
 *  - display mode: readOnly (default). Shows filled stars, optional value/count text.
 *  - editable: pass onChange to receive 1..5.
 */
export default function Rating({ value = 0, onChange, size = 16, count, testId, showValue = true, className = "" }) {
  const [hover, setHover] = React.useState(0);
  const editable = typeof onChange === "function";
  const shown = hover || value;

  return (
    <span className={`inline-flex items-center gap-1 ${className}`} data-testid={testId}>
      <span className="inline-flex">
        {[1, 2, 3, 4, 5].map((i) => {
          const filled = i <= shown;
          return (
            <button
              key={i}
              type="button"
              disabled={!editable}
              onMouseEnter={() => editable && setHover(i)}
              onMouseLeave={() => editable && setHover(0)}
              onClick={() => editable && onChange(i)}
              data-testid={testId ? `${testId}-star-${i}` : undefined}
              className={editable ? "p-0.5 cursor-pointer" : "p-0.5 cursor-default"}
              aria-label={`${i} star${i > 1 ? "s" : ""}`}
            >
              <Star
                width={size} height={size}
                className={filled ? "fill-amber-500 text-amber-500" : "text-slate-300"}
              />
            </button>
          );
        })}
      </span>
      {showValue && value > 0 && !editable && (
        <span className="text-sm font-medium text-slate-900">{Number(value).toFixed(1)}</span>
      )}
      {count !== undefined && !editable && (
        <span className="text-sm text-slate-500">
          {count === 0 ? "No reviews yet" : `${count} review${count > 1 ? "s" : ""}`}
        </span>
      )}
    </span>
  );
}
